import React from "react";
import { Typography } from "@mui/material";

import classes from "./SummarySegmentDetails.module.css";
import { useSelector } from "react-redux";

export default function SummarySegmentDetail(props) {
  const { origin, destination, startTime, endTime, baggage, localStartTime, localEndTime } = props;

  function formatTime(time) {
    return time < 10 ? `0${time}` : `${time}`;
  }
  function getTimeFormatted(timeString) {
    const value = timeString.replaceAll("/", "-").replaceAll(" ", "T")
    const hrs = value.split("T")[1].split(":")[0]
    const min = value.split("T")[1].split(":")[1]
    return `${hrs}:${min}`;
  }

  function getDurationString(start, end) {
    const startTime = new Date(start);
    const endTime = new Date(end);
    let durationInMilisec = endTime - startTime;
    const durationHr = Math.floor(durationInMilisec / 3600000);
    durationInMilisec %= 3600000;
    const durationMin = durationInMilisec / 60000;
    return `${durationHr > 0 ? `${durationHr} h` : ""} ${durationMin} m`;
  }

  return (
    <div className={classes["segment-details"]}>
      <div className={classes["segment-details2"]}>
        <div className={classes["segment-details__time-range"]}>
          <Typography
            variant="p"
            fontWeight={700}
            className={classes["start-time"]}
          >
            {getTimeFormatted(localStartTime)}
          </Typography>
          <Typography
            variant="p"
            fontWeight={700}
            className={classes["end-time"]}
          >
            {getTimeFormatted(localEndTime)}
          </Typography>
        </div>
        <div className={classes["segment-details__vline"]}></div>
        <div className={classes["segment-details__detail"]}>
          <Typography fontWeight={700} marginBottom="1rem">
            {origin}
          </Typography>
          <div className={classes.duration}>
            {getDurationString(startTime, endTime)}
          </div>
          <Typography fontWeight={700} marginTop="1rem">
            {destination}
          </Typography>
        </div>
      </div>
      <div
        className={`${classes["segment-details__flight-detail"]} col-sm-12 col-xs-12 col-md-3`}
      >
        <div style={{ marginLeft: "auto" }}>
          <Typography fontWeight={700} textAlign="left">
            Baggage
          </Typography>
          <Typography marginTop="1rem" color="#3a3a3a" textAlign="left">
            Check in
            {baggage && (baggage?.hand_weight || baggage[0])
              ? baggage?.hand_weight
                ? baggage?.hand_weight
                : baggage[0].adult
              : 0}
          </Typography>
          <Typography marginTop="0.5rem" color="#3a3a3a" textAlign="left">
            Cabin
            {baggage && (baggage?.hold_weight || baggage[1])
              ? baggage?.hold_weight
                ? baggage?.hold_weight
                : baggage[1].adult
              : 0}
          </Typography>
        </div>
        {/* <div className="col-sm-6">
          <Typography fontWeight={700}> </Typography>
          <Typography marginTop="1rem"></Typography>
          <Typography marginTop="0.5rem"></Typography>
        </div> */}
      </div>
    </div>
  );
}
